import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import UserRoleAnalysis from "./UserRoleAnalysis";
import { NGROK } from "../../../../APIs";
import { myLocalStorage } from "../../../../components/StorageHelper";
import K8TokenAnalytics from "../../NHI/K8TokenAnalytics";
import InfoIcon from "@mui/icons-material/Info";
import TimelineIcon from "@mui/icons-material/Timeline";
import TailwindCollapsibleTable from "../../../../tailwind-ui/components/TailwindCollapsibleTable";
import CloudEntityAnalytics from "../../../../components/v2components/CloudAnalytics/CloudEntityAnalytics";

const NHIServiceAccoutDetails = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState("details");

  const [details] = useState(() => {
    return state || JSON.parse(myLocalStorage.getItem("nhi-details")) || {};
  });

  const {
    tenantName,
    cloudType = "",
    cloudNHIType,
    secretDetails,
    tokenDetails,
    cloudTokenDetails,
    serviceDetails,
    cloudSecret,
    serviceAccountEmail,
    roles,
    syncedAt,
    principalId,
    secretName,
    nameSpace,
    from,
    oidcARN,
    oidc,
  } = details;


  const latestSubList = JSON.parse(myLocalStorage.getItem("latestSubList"));
  const projectId = myLocalStorage.getItem("gcpSelectedProjectId");
  const accountId = myLocalStorage.getItem("selectedAwsAccount");
  const subscriptionId = latestSubList?.azureSubscriptionId;

  const cloudTokeKeyId = cloudTokenDetails?.keyId;

  const createApiUrl = (base, params) =>
    `${NGROK}${base}?${new URLSearchParams(params).toString()}`;

  const commonParams = {
    tenantName,
    timeRangeCode: 7,
    ...(cloudType === "GCP"
      ? { projectId }
      : cloudType === "AZURE"
        ? { subscriptionId }
        : { accountId }),
  };
  const cloudId =
    cloudType === "GCP"
      ? projectId
      : cloudType === "AZURE"
        ? subscriptionId
        : accountId;

  const emailOrUserId =
    cloudType === "GCP"
      ? { email: serviceAccountEmail }
      : cloudType === "AZURE"
        ? { userId: principalId }
        : { accountId: accountId };

  const nameParam = { name: secretName };
  const secretParam =
    cloudNHIType === "TOKEN"
      ? { tokenName: cloudTokeKeyId }
      : cloudType === "AWS"
        ? { arn: secretName }
        : { secretName };

  let resourceAPI = "";
  let permissionApi = "";
  let resolutionApi = "";
  let suggestionApi = "";
  let tokenLogsAPI = "";
  let tokenUsageAPI = "";
  let roleBindingURL = "";
  switch (cloudNHIType) {
    case "TOKEN":
      resourceAPI = createApiUrl(
        `/api/${cloudType.toLowerCase()}/analytics/get-tokens-resource-usage`,
        { ...commonParams, ...secretParam },
      );
      permissionApi = createApiUrl(
        `/api/${cloudType.toLowerCase()}/analytics/get-tokens-permission-usage`,
        { ...commonParams, ...secretParam },
      );
      break;

    case "SECRET":
      resourceAPI = createApiUrl(
        `/api/${cloudType.toLowerCase()}/analytics/get-secrets-resource-usage`,
        { ...commonParams, ...secretParam },
      );
      permissionApi = createApiUrl(
        `/api/${cloudType.toLowerCase()}/analytics/get-secrets-permission-usage`,
        { ...commonParams, ...secretParam },
      );
      break;

    case "K8SERVICE":
      resourceAPI = createApiUrl(
        `/api/${cloudType.toLowerCase()}/analytics/get-k8-service-account-resource-usage`,
        { ...commonParams, ...nameParam, nameSpace: nameSpace },
      );
      permissionApi = createApiUrl(
        `/api/${cloudType.toLowerCase()}/analytics/get-k8-service-account-permission-usage`,
        { ...commonParams, ...nameParam, nameSpace: nameSpace },
      );
      break;

    case "K8TOKEN":
      resourceAPI = createApiUrl(
        `/api/${cloudType.toLowerCase()}/analytics/get-k8-token-resource-usage`,
        { ...commonParams, ...nameParam, nameSpace: nameSpace },
      );
      permissionApi = createApiUrl(
        `/api/${cloudType.toLowerCase()}/analytics/get-k8-token-permission-usage`,
        { ...commonParams, ...nameParam, nameSpace: nameSpace },
      );
      tokenLogsAPI = createApiUrl(`/api/k8/v1/getLogs`, {
        ...commonParams,
        ...nameParam,
        name: secretName,
      });
      tokenUsageAPI = createApiUrl(`/api/k8/v1/getUsages`, {
        ...commonParams,
        ...nameParam,
        name: secretName,
      });
      roleBindingURL = createApiUrl(`/api/k8/v1/getBindings`, {
        ...commonParams,
        ...nameParam,
        name: secretName,
      });
      break;

    case "K8SECRET":
      resourceAPI = createApiUrl(
        `/api/${cloudType.toLowerCase()}/analytics/get-k8-secret-resource-usage`,
        { ...commonParams, ...nameParam, nameSpace: nameSpace },
      );
      permissionApi = createApiUrl(
        `/api/${cloudType.toLowerCase()}/analytics/get-k8-secret-permission-usage`,
        { ...commonParams, ...nameParam, nameSpace: nameSpace },
      );
      break;

    case "OIDC":
      resourceAPI = createApiUrl(
        `/api/${cloudType.toLowerCase()}/analytics/get-oidc-resource-usage`,
        { ...commonParams, ...emailOrUserId, arn: oidcARN } || {},
      );
      permissionApi = createApiUrl(
        `/api/${cloudType.toLowerCase()}/analytics/get-oidc-permission-usage`,
        { ...commonParams, ...emailOrUserId, arn: oidcARN } || {},
      );
      resolutionApi = createApiUrl(
        `/api/${cloudType.toLowerCase()}/analytics/get-oidc-analytics-resolutions`,
        { ...commonParams, ...emailOrUserId, arn: oidcARN } || {},
      );
      suggestionApi = createApiUrl(
        `/api/${cloudType.toLowerCase()}/analytics/get-oidc-analytics-suggestions`,
        { ...commonParams, ...emailOrUserId, arn: oidcARN } || {},
      );
      break;
    default:
      if (from === "IAMRoleNHI") {
        resourceAPI = createApiUrl(
          `/api/${cloudType.toLowerCase()}/analytics/get-iam-role-resource-usage`,
          { ...commonParams, ...emailOrUserId, arn: roles[0]?.roleARN } || {},
        );
        permissionApi = createApiUrl(
          `/api/${cloudType.toLowerCase()}/analytics/get-iam-role-permission-usage`,
          { ...commonParams, ...emailOrUserId, arn: roles[0]?.roleArn } || {},
        );
        resolutionApi = createApiUrl(
          `/api/${cloudType.toLowerCase()}/analytics/get-iam-role-analytics-resolutions`,
          { ...commonParams, ...emailOrUserId, arn: roles[0]?.roleArn } || {},
        );
        suggestionApi = createApiUrl(
          `/api/${cloudType.toLowerCase()}/analytics/get-iam-role-analytics-suggestions`,
          { ...commonParams, ...emailOrUserId, arn: roles[0]?.roleArn } || {},
        );
      } else {
        resourceAPI = createApiUrl(
          `/api/${cloudType.toLowerCase()}/analytics/get-user-resource-usage`,
          { ...commonParams, ...emailOrUserId },
        );
        permissionApi = createApiUrl(
          `/api/${cloudType.toLowerCase()}/analytics/get-user-permission-usage`,
          { ...commonParams, ...emailOrUserId },
        );
        resolutionApi = createApiUrl(
          `/api/${cloudType.toLowerCase()}/analytics/get-user-analytics-resolutions`,
          { ...commonParams, ...emailOrUserId },
        );
        suggestionApi = createApiUrl(
          `/api/${cloudType.toLowerCase()}/analytics/get-user-analytics-suggestions`,
          { ...commonParams, ...emailOrUserId },
        );
      }
  }

  const convertProtobufTimestamp = (str) => {
    try {
      const seconds = parseInt(str.match(/seconds:\s*(\d+)/)?.[1] || 0);
      const nanos = parseInt(str.match(/nanos:\s*(\d+)/)?.[1] || 0);
      return new Date(seconds * 1000 + nanos / 1e6).toLocaleString("en-GB");
    } catch {
      return "Invalid date";
    }
  };

  const back = () => navigate(-1);

  const renderKV = (label, value) => (
    <div>
      <p className="text-sm text-gray-500">{label}</p>
      <p className="text-base text-black break-all">{value}</p>
    </div>
  );

  const renderDetailsSection = () => {
    switch (cloudNHIType) {
      case "SECRET":
        return (
          <>
            {cloudType === "AWS"
              ? renderKV("Secret ARN", secretName)
              : renderKV("Secret Name", cloudSecret?.displayName)}
            {renderKV("Resource Path", cloudSecret?.name)}
            {cloudType === "AWS"
              ? renderKV("Account ID", accountId)
              : renderKV("Project ID", cloudSecret?.projectId)}
            {renderKV("Replication Type", cloudSecret?.replicationType)}
            {renderKV(
              "Rotation Enabled",
              cloudSecret?.rotationEnabled ? "Yes" : "No",
            )}
            {renderKV(
              "Managed By",
              cloudSecret?.isManagedSecret ? "System Managed" : "User Managed",
            )}
            {renderKV(
              "Created",
              convertProtobufTimestamp(
                cloudSecret?.createTime || cloudSecret?.createdAt,
              ),
            )}
          </>
        );

      case "TOKEN":
        return (
          <>
            {renderKV(
              "Service Account Email",
              cloudTokenDetails?.serviceAccountEmail,
            )}
            {renderKV("Key ID", cloudTokenDetails?.keyId)}
            {renderKV("Key Algorithm", cloudTokenDetails?.keyAlgo)}
            {renderKV(
              "Valid After",
              new Date(cloudTokenDetails?.validAfter).toLocaleString("en-GB"),
            )}
            {renderKV(
              "Valid Before",
              new Date(cloudTokenDetails?.validBefore).toLocaleString("en-GB"),
            )}
            {renderKV("Project ID", cloudTokenDetails?.projectId)}
            {renderKV(
              "Managed By",
              cloudTokenDetails?.isManagedKey
                ? "Google Managed"
                : "User Managed",
            )}
          </>
        );

      case "K8SERVICE":
      case "K8TOKEN":
      case "K8SECRET":
        const item =
          cloudNHIType === "K8SERVICE"
            ? serviceDetails
            : cloudNHIType === "K8TOKEN"
              ? tokenDetails
              : secretDetails;

        return (
          <>
            {renderKV("Name", item?.name)}
            {renderKV("Cluster", item?.clusterId)}
            {renderKV("Namespace", item?.namespace)}
            {item?.type && renderKV("Type", item?.type)}
            {renderKV(
              "Synced At",
              new Date(item?.syncedAt).toLocaleString("en-GB"),
            )}
            {renderKV("Cloud Provider", item?.cloudProviderType)}
            {item?.labels &&
              renderKV("Labels", JSON.stringify(item.labels, null, 2))}
            {item?.annotations &&
              renderKV(
                "Annotations",
                JSON.stringify(item.annotations, null, 2),
              )}
          </>
        );

      case "OIDC":
        return (
          <>
            {renderKV("URL", oidc.url)}
            {renderKV("Provider ARN", oidc.providerArn || "-")}
            {renderKV("Client Id", oidc.clientIds?.join(", ") || "-")}
            {renderKV(
              "Created  At",
              new Date(oidc.createDate).toLocaleString("en-GB"),
            )}
          </>
        );

      default:
        return (
          <>
            {cloudType === "GCP"
              ? renderKV("Project ID", projectId)
              : cloudType === "AZURE"
                ? renderKV("Subscription", latestSubList?.subscriptionName)
                : renderKV("Account ID", accountId)}
            {cloudType === "AWS"
              ? renderKV("RoleName", serviceAccountEmail)
              : renderKV("Account Email", serviceAccountEmail)}
            {renderKV("Synced At", new Date(syncedAt).toLocaleString("en-GB"))}
            {roles?.length > 0
              ? renderKV("Roles", roles.map((r) => r.roleName).join(", "))
              : renderKV("Roles", "No roles assigned.")}
          </>
        );
    }
  };

  const getSectionTitle = () => {
    switch (cloudNHIType) {
      case "SECRET":
        return "Secret Details";
      case "TOKEN":
        return "Token Details";
      case "K8SERVICE":
        return "Kubernetes Service Account Details";
      case "K8TOKEN":
        return "Kubernetes Token Details";
      case "K8SECRET":
        return "Kubernetes Secret Details";
      case "OIDC":
        return "OIDC Details";
      default:
        return "Service Account Details";
    }
  };

  const getEntityName = () => {
    if (cloudType?.toUpperCase() === "AWS") return myLocalStorage.getItem("selectedAwsAccount");
    else if (cloudType?.toUpperCase() === "AZURE") return JSON.parse(
      myLocalStorage.getItem("latestSubList"),
    )?.subscriptionName;
    else return myLocalStorage.getItem("gcpSelectedProjectId");
  }

  const getDetails = () => {
    if (cloudNHIType?.toUpperCase() === "SECRET") {
      return (
        cloudSecret ||
        secretDetails ||
        details?.cloudSecretDetails ||
        details?.secretDetails ||
        {}
      );
    }
    else if (cloudNHIType?.toUpperCase() === "TOKEN") return cloudTokenDetails?.tokenDetails || cloudTokenDetails || {};
    else if (cloudNHIType?.toUpperCase() === "K8SECRET") return secretDetails || {};
    else if (cloudNHIType?.toUpperCase() === "K8TOKEN") return tokenDetails || {};
    else if (cloudNHIType?.toUpperCase() === "K8SERVICE") return serviceDetails || {};
  }

  const analyticsEntityName =
    cloudNHIType?.toUpperCase() === "SECRET" || cloudNHIType?.toUpperCase() === "K8SECRET"
      ? secretName
      : serviceAccountEmail;

  return (
    cloudNHIType === "K8TOKEN" ?
      <>
        <div className="p-6">
          <div className="w-full p-6 bg-white border border-gray-200 rounded-lg shadow">
            <button
              onClick={back}
              className="flex items-center mb-4 text-base font-semibold underline"
            >
              ← Back
            </button>
            <h2 className="mb-6 text-2xl font-semibold">{getSectionTitle()}</h2>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3">
              {renderDetailsSection()}
            </div>
          </div>
          <K8TokenAnalytics
            tenantName={tenantName}
            projectId={projectId}
            userEmail={serviceAccountEmail}
            cloudType={cloudType}
            cloudNHIType={cloudNHIType}
            logsURL={tokenLogsAPI}
            usageURL={tokenUsageAPI}
            roleBindingURL={roleBindingURL}
          />
        </div>
      </>
      :
      <CloudEntityAnalytics
        cloudProvider={cloudType.toLowerCase()}
        email={analyticsEntityName}
        entityId={analyticsEntityName}
        entityType={"nhi"}
        cloudNHIType={cloudNHIType}
        details={details}
        roles={details.roles || []}
        syncedAt={syncedAt}
        entityName={getEntityName()}
        extrasdetails={getDetails()}
      />

  );
};

export default NHIServiceAccoutDetails;
